import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { browserTimezone } from '@/utils/dt';

export const useTimezoneStore = defineStore('timezone', () => {
    const _saved = ref<string | null>(null);
    const _browser = browserTimezone();

    /** The active timezone: user-saved preference, or browser timezone as fallback. */
    const effectiveTimezone = computed(() => _saved.value ?? _browser);

    /**
     * Set the timezone from a user profile / account settings.
     * Call this when account settings are loaded or saved.
     * Future use: also call from the auth/session API response.
     */
    function setFromProfile(tz: string | null | undefined) {
        _saved.value = tz || null;
    }

    /** Resolves once the profile timezone has been resolved (set or failed). */
    let _resolveReady!: () => void;
    const whenReady = new Promise<void>((resolve) => { _resolveReady = resolve; });

    function markReady() {
        _resolveReady();
    }

    function clearUserTimezone() {
        _saved.value = null;
    }

    return { effectiveTimezone, whenReady, setFromProfile, markReady, clearUserTimezone, browserTimezone: _browser };
});
